// Scroll indicator arrows for horizontal pill menus (2026-06-05 call
// decision). Wraps a scrollable pill list: shows a left/right arrow when
// more pills exist beyond the visible area, hides them at the ends.
// Markup contract:
//   <pill-scroll>
//     <button data-pill-scroll-left hidden>…</button>
//     <ul data-pill-scroller>…</ul>
//     <button data-pill-scroll-right hidden>…</button>
//   </pill-scroll>
class PillScroll extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('[data-pill-scroller]');
    if (!this.scroller) return;

    this.leftArrow = this.querySelector('[data-pill-scroll-left]');
    this.rightArrow = this.querySelector('[data-pill-scroll-right]');
    this.update = this.update.bind(this);

    this.scroller.addEventListener('scroll', this.update, { passive: true });
    window.addEventListener('resize', this.update);
    this.leftArrow?.addEventListener('click', () => this.scrollByDir(-1));
    this.rightArrow?.addEventListener('click', () => this.scrollByDir(1));

    this.update();
    // Re-check once fonts settle and layout stabilizes
    requestAnimationFrame(this.update);
    setTimeout(this.update, 350);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.update);
  }

  scrollByDir(direction) {
    this.scroller.scrollBy({
      left: direction * this.scroller.clientWidth * 0.6,
      behavior: 'smooth',
    });
  }

  update() {
    const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth - 1;
    if (this.leftArrow) this.leftArrow.hidden = this.scroller.scrollLeft <= 1;
    if (this.rightArrow) this.rightArrow.hidden = this.scroller.scrollLeft >= maxScroll;
  }
}

if (!customElements.get('pill-scroll')) {
  customElements.define('pill-scroll', PillScroll);
}
